import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Popper,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ProdutoModel from 'models/Produto';
import { FaBuilding, FaInfoCircle } from 'react-icons/fa';
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  Row,
} from 'reactstrap';

import Select, { StylesConfig } from 'react-select';
import ProdutoCategoria from 'models/ProdutoCategoria';
import api from 'services/api';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import OpcaoMostrarBotoes from 'staticData/OpcaoMostrarBotoes';
import Swal from 'sweetalert2';
import SelectProdutos from 'utils/SelectProdutos';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import ProdutoAtividade from 'models/ProdutoAtividade';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import { Autocomplete } from '@material-ui/lab';

interface ProdutoAssociado {
  produtoRelacao: {
    id: number;
    nome: string;
  };
}

interface ModalProdutoProps {
  produtos: ProdutoModel[];
  setFormModalState: React.Dispatch<React.SetStateAction<boolean>>;
  formModalState: boolean;
  produtoEditing: ProdutoModel;
  setProdutoEditing: React.Dispatch<React.SetStateAction<ProdutoModel>>;
  produtoCategorias: ProdutoCategoria[];
  carregaProdutos: () => void;
  produtosAssociados: { label: string; value: number }[];
  setProdutosAssociados: React.Dispatch<
    React.SetStateAction<
      {
        label: string;
        value: number;
      }[]
    >
  >;
  produtosSelecao: any[];
  isCreate: boolean;
}

const styles = () => ({
  popper: {
    width: 'fit-content',
  },
});

const PopperMy = function (props: any) {
  return <Popper {...props} style={styles().popper} placement="bottom-start" />;
};

export default function ModalProduto({
  produtos,
  setFormModalState,
  produtoEditing,
  formModalState,
  setProdutoEditing,
  produtoCategorias,
  carregaProdutos,
  produtosAssociados,
  setProdutosAssociados,
  produtosSelecao,
  isCreate,
}: ModalProdutoProps): JSX.Element {
  const [produtosAssociadosIniciais, setProdutosAssociadosIniciais] = useState<
    ProdutoModel[]
  >([]);

  const [isLoading, setIsLoading] = useState(false);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] =
    useState<iAutoCompleteItem | null>(null);
  const [materialSelecionadoFrete, setMaterialSelecionadoFrete] =
    useState<iAutoCompleteItem | null>(null);
  const [materialSelecionadoMaoObra, setMaterialSelecionadoMaoObra] =
    useState<iAutoCompleteItem | null>(null);

  const [atividades, setAtividades] = useState<ProdutoAtividade[]>([]);

  async function listaAtividades(id: number) {
    const response = await api.get(`/produto-atividade?produtoId=${id}`);
    setAtividades(response.data);
  }

  useEffect(() => {
    if (produtoEditing) {
      listaAtividades(produtoEditing.id);
    }
  }, [produtoEditing]);

  function InputSelectPermiteBotoes(): JSX.Element {
    return (
      <TextField
        select
        label="Mostrar nas telas"
        variant="outlined"
        size="small"
        value={produtoEditing.opcaoMostrarBotoes || 4}
        onChange={event =>
          setProdutoEditing({
            ...produtoEditing,
            opcaoMostrarBotoes: Number(event.target.value),
          })
        }
        fullWidth
      >
        {/* <MenuItem value="" disabled>
          Selecione uma opção
        </MenuItem> */}

        {OpcaoMostrarBotoes.map(op => (
          <MenuItem key={op.id} value={op.id}>
            {op.label}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  async function handleCreateProduto() {
    setIsLoading(true);
    toast.loading(isCreate ? 'Criando...' : 'Salvando...', {
      position: 'top-center',
    });
    const {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      geraPS,
      geraPedido,
      opcaoMostrarBotoes,
      permiteFatDireto,
      setorAtividade,
      pepTemplate,
      elementosPepGerar,
      centroLucro,
    } = produtoEditing;
    if (!nome || (!codigoEmpresa && !setorAtividade) || !produtoCategoriaId) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'É necessário informar o nome, categoria e empresa/setor atividade do produto',
      });
      return;
    }

    if (
      produtoEditing.regramentoProposta &&
      (!produtoEditing.atividadeFrete ||
        !produtoEditing.atividadeMaoObra ||
        !produtoEditing.sequenciaFrete ||
        !produtoEditing.sequenciaMaoObra ||
        !(materialSelecionadoFrete?.codigo ?? produtoEditing.materialFrete) ||
        !(materialSelecionadoMaoObra?.codigo ?? produtoEditing.materialMaoObra))
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'É necessário informar todos os dados de material frete e material mão de obra quando regramento for específico',
      });
      setIsLoading(false);
      toast.dismiss();
      return;
    }

    try {
      await api.post(`/produto`, {
        nome,
        codigoEmpresa,
        produtoCategoriaId,
        nomeProposta,
        bloquearProdutosDiferentes,
        geraGnf,
        geraPS,
        geraPedido,
        opcaoMostrarBotoes,
        produtoPrincipalId: produtoEditing.id,
        produtosARelacionar: produtosAssociados,
        finame: produtoEditing.finame,
        setorAtividade: produtoEditing.setorAtividade,
        ncm: produtoEditing.ncm,
        produtosAssociadosIniciais,
        permiteFatDireto,
        pepTemplate,
        elementosPepGerar,
        codigoMaterial: itemDomsgeSelecionado?.codigo,
        regramentoProposta: produtoEditing.regramentoProposta,
        codigoMaterialFrete: materialSelecionadoFrete?.codigo,
        codigoMaterialMaoObra: materialSelecionadoMaoObra?.codigo,
        atividadeFrete: produtoEditing.atividadeFrete,
        atividadeMaoObra: produtoEditing.atividadeMaoObra,
        sequenciaFrete: produtoEditing.sequenciaFrete,
        sequenciaMaoObra: produtoEditing.sequenciaMaoObra,
        centroLucro,
      });
      toast.success(isCreate ? 'Produto criado' : 'Produto salvo');
    } catch (error: any) {
      const mensagemErro = error.response.data.message;
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: mensagemErro ?? 'Houve um problema ao criar o produto!',
      });
    } finally {
      toast.dismiss();
    }

    setFormModalState(false);
    carregaProdutos();
    setIsLoading(false);
    toast.dismiss();
  }

  function handleSelecionarItem(material: iAutoCompleteItem | null) {
    setItemDomsgeSelecionado(material);
  }
  function handleSelecionarItemFrete(material: iAutoCompleteItem | null) {
    setMaterialSelecionadoFrete(material);
  }
  function handleSelecionarItemMaoObra(material: iAutoCompleteItem | null) {
    setMaterialSelecionadoMaoObra(material);
  }

  // Isso é temporário, pois o componente está com um problema
  async function limparCamposFreteMaoObra() {
    const data = await api.put(`/produto/frete-mao-obra/${produtoEditing.id}`);
    window.location.reload();
  }

  async function handleUpdateProduto() {
    setIsLoading(true);
    toast.loading('Salvando...', { position: 'top-center' });
    const {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      geraPS,
      pepTemplate,
      geraPedido,
      opcaoMostrarBotoes,
      permiteFatDireto,
      setorAtividade,
      elementosPepGerar,
      centroLucro,
    } = produtoEditing;
    if (!nome || (!codigoEmpresa && !setorAtividade) || !produtoCategoriaId) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'É necessário informar o nome, categoria e empresa/setor atividade do produto',
      });
      setIsLoading(false);
      toast.dismiss();
      return;
    }

    if (
      produtoEditing.regramentoProposta &&
      (!produtoEditing.atividadeFrete ||
        !produtoEditing.atividadeMaoObra ||
        !produtoEditing.sequenciaFrete ||
        !produtoEditing.sequenciaMaoObra ||
        !(materialSelecionadoFrete?.codigo ?? produtoEditing.materialFrete) ||
        !(materialSelecionadoMaoObra?.codigo ?? produtoEditing.materialMaoObra))
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'É necessário informar todos os dados de material frete e material mão de obra quando regramento for específico',
      });
      setIsLoading(false);
      toast.dismiss();
      return;
    }

    try {
      await api.put(`/produto/${produtoEditing.id}`, {
        nome,
        codigoEmpresa,
        produtoCategoriaId,
        nomeProposta,
        bloquearProdutosDiferentes,
        geraGnf,
        geraPS,
        geraPedido,
        pepTemplate,
        opcaoMostrarBotoes,
        produtoPrincipalId: produtoEditing.id,
        produtosARelacionar: produtosAssociados,
        finame: produtoEditing.finame,
        setorAtividade: produtoEditing.setorAtividade,
        ncm: produtoEditing.ncm,
        produtosAssociadosIniciais,
        permiteFatDireto,
        elementosPepGerar,
        codigoMaterial: itemDomsgeSelecionado?.id ?? produtoEditing.materialId,
        regramentoProposta: produtoEditing.regramentoProposta,
        codigoMaterialFrete:
          materialSelecionadoFrete?.id ?? produtoEditing.materialFrete,
        codigoMaterialMaoObra:
          materialSelecionadoMaoObra?.id ?? produtoEditing.materialMaoObra,
        atividadeFrete: produtoEditing.atividadeFrete,
        atividadeMaoObra: produtoEditing.atividadeMaoObra,
        sequenciaFrete: produtoEditing.sequenciaFrete,
        sequenciaMaoObra: produtoEditing.sequenciaMaoObra,
        centroLucro,
      });

      toast.success('Produto salvo');
    } catch (error: any) {
      const mensagemErro = error.response.data.message;
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: mensagemErro ?? 'Houve um problema ao atualizar o produto!',
      });
    } finally {
      toast.dismiss();
    }

    setFormModalState(false);
    setProdutoEditing({} as ProdutoModel);
    carregaProdutos();
    setIsLoading(false);
    toast.dismiss();
  }

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={formModalState}
        toggle={() => setFormModalState(prev => !prev)}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <small>
                  {isCreate
                    ? 'Criar Produto'
                    : `Produto ${produtoEditing.nome}`}
                </small>
              </div>
              <Form role="form">
                <FormGroup className="mb-3">
                  <Row>
                    <Col>
                      <TextField
                        fullWidth
                        label="Nome do produto"
                        size="small"
                        value={produtoEditing.nome || ''}
                        type="text"
                        variant="outlined"
                        id="outlined-basic"
                        onChange={e =>
                          setProdutoEditing({
                            ...produtoEditing,
                            nome: e.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col>
                      <TextField
                        fullWidth
                        label="Código da empresa"
                        size="small"
                        variant="outlined"
                        id="outlined-basic"
                        value={produtoEditing.codigoEmpresa ?? ''}
                        type="number"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            codigoEmpresa: String(text.target.value),
                          })
                        }
                        InputProps={{ inputProps: { min: 0, max: 10 } }}
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <FormGroup className="mb-3">
                  <TextField
                    fullWidth
                    label="Descrição do produto na proposta"
                    variant="outlined"
                    id="outlined-basic"
                    size="small"
                    value={produtoEditing.nomeProposta ?? produtoEditing.nome}
                    InputLabelProps={{
                      shrink: Boolean(
                        produtoEditing.nomeProposta ?? produtoEditing.nome,
                      ),
                    }}
                    type="text"
                    onChange={text =>
                      setProdutoEditing({
                        ...produtoEditing,
                        nomeProposta: text.target.value,
                      })
                    }
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Row>
                    <Col>
                      <TextField
                        fullWidth
                        label="Finame"
                        variant="outlined"
                        id="outlined-basic"
                        size="small"
                        value={produtoEditing?.finame ?? ''}
                        type="text"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            finame: text.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col>
                      <TextField
                        fullWidth
                        label="Ncm"
                        variant="outlined"
                        id="outlined-basic"
                        size="small"
                        value={produtoEditing.ncm ?? ''}
                        type="text"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            ncm: text.target.value,
                          })
                        }
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <Row>
                  <Col>
                    <TextField
                      fullWidth
                      label="Setor de Atividade"
                      variant="outlined"
                      id="outlined-basic"
                      size="small"
                      value={produtoEditing?.setorAtividade ?? ''}
                      type="text"
                      // maxLength={2}
                      onChange={text =>
                        setProdutoEditing({
                          ...produtoEditing,
                          setorAtividade: text.target.value,
                        })
                      }
                    />
                  </Col>
                  <Col>
                    <TextField
                      select
                      label="Categoria"
                      variant="outlined"
                      size="small"
                      value={produtoEditing.produtoCategoriaId ?? ''}
                      onChange={e =>
                        setProdutoEditing({
                          ...produtoEditing,
                          produtoCategoriaId: Number(e.target.value),
                        })
                      }
                      fullWidth
                    >
                      <MenuItem value="" disabled>
                        Selecione uma categoria
                      </MenuItem>

                      {produtoCategorias.map(produtoCategoria => (
                        <MenuItem
                          key={produtoCategoria.id}
                          value={produtoCategoria.id}
                        >
                          {produtoCategoria.descricao}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Col>
                </Row>

                <Row>
                  <Col sm="6" className="mt-3 d-flex">
                    <TextField
                      fullWidth
                      label="Elemento PEP Template"
                      variant="outlined"
                      id="outlined-basic"
                      size="small"
                      value={produtoEditing?.pepTemplate ?? ''}
                      type="text"
                      onChange={text =>
                        setProdutoEditing({
                          ...produtoEditing,
                          pepTemplate: text.target.value,
                        })
                      }
                    />
                  </Col>
                  <Col sm="6" className="mt-3 d-flex">
                    <TextField
                      fullWidth
                      label="Elementos Sem Material (sep. vírgula)"
                      variant="outlined"
                      id="outlined-basic"
                      size="small"
                      value={produtoEditing?.elementosPepGerar ?? ''}
                      type="text"
                      onChange={text =>
                        setProdutoEditing({
                          ...produtoEditing,
                          elementosPepGerar: text.target.value,
                        })
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="6" className="mt-3 d-flex">
                    <TextField
                      fullWidth
                      label="Centro Lucro"
                      variant="outlined"
                      id="outlined-basic"
                      size="small"
                      value={produtoEditing?.centroLucro ?? ''}
                      type="text"
                      onChange={text =>
                        setProdutoEditing({
                          ...produtoEditing,
                          centroLucro: text.target.value,
                        })
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup className="mt-3 d-flex">
                      <InputGroup className="input-group-alternative justify-content-left  p-2 d-flex align-items-center">
                        <Tooltip title="Bloqueia o uso de produtos diferentes">
                          <strong className="h5 mb-0 mr-2">
                            Bloqueia produtos diferentes
                          </strong>
                        </Tooltip>
                        <label className="custom-toggle">
                          <input
                            type="checkbox"
                            onChange={() =>
                              setProdutoEditing({
                                ...produtoEditing,
                                bloquearProdutosDiferentes:
                                  !produtoEditing.bloquearProdutosDiferentes,
                              })
                            }
                            checked={produtoEditing.bloquearProdutosDiferentes}
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            placeholder="teste"
                          />
                        </label>
                      </InputGroup>
                      <InputGroup className="input-group-alternative justify-content-left mr-4 p-2 d-flex align-items-center">
                        <Tooltip title="Bloqueia o uso de produtos diferentes">
                          <strong className="h5 mb-0 mr-2">
                            Permite faturamento direto
                          </strong>
                        </Tooltip>
                        <label className="custom-toggle">
                          <input
                            type="checkbox"
                            onChange={() =>
                              setProdutoEditing({
                                ...produtoEditing,
                                permiteFatDireto:
                                  !produtoEditing.permiteFatDireto,
                              })
                            }
                            checked={produtoEditing.permiteFatDireto}
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            placeholder="teste"
                          />
                        </label>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <FormGroup className="mt-3">
                      <InputGroup className="input-group-alternative justify-content-left p-2 d-flex align-items-center">
                        <Tooltip title="Custo financeiro e comissão deverão ser informado por um superior">
                          <span
                            className={`ml-2 h5 mb-0 mr-2 ${
                              !produtoEditing.regramentoProposta
                                ? 'text-primary'
                                : 'text-muted'
                            }`}
                          >
                            Regramento Geral
                          </span>
                        </Tooltip>
                        <label className="custom-toggle">
                          <input
                            type="checkbox"
                            checked={produtoEditing.regramentoProposta}
                            onChange={() =>
                              setProdutoEditing({
                                ...produtoEditing,
                                regramentoProposta:
                                  !produtoEditing.regramentoProposta,
                              })
                            }
                          />
                          <span className="custom-toggle-slider rounded-circle" />
                        </label>
                        <Tooltip
                          title="
                          Custo financeiro e comissão serão calculados pelo sistema
                          "
                        >
                          <span
                            className={`ml-2 h5 mb-0 mr-2 ${
                              produtoEditing.regramentoProposta
                                ? 'text-primary'
                                : 'text-muted'
                            }`}
                          >
                            Regramento Específico
                          </span>
                        </Tooltip>
                      </InputGroup>
                    </FormGroup>
                    {/* </Col>
                    <Col> */}
                  </Col>
                  <Col sm="12">
                    <FormGroup className="mt-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            className="mr-1 float-center"
                            checked={produtoEditing.geraGnf}
                            title="Gerar GNF"
                            onChange={event => {
                              setProdutoEditing({
                                ...produtoEditing,
                                geraGnf: event.target.checked,
                                geraPedido: false,
                                geraPS: false,
                              });
                            }}
                          />
                        }
                        label="Gerar GNF"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            className="mr-1 float-center"
                            checked={produtoEditing.geraPedido}
                            title="Gerar Pedido"
                            onChange={event => {
                              setProdutoEditing({
                                ...produtoEditing,
                                geraPedido: event.target.checked,
                                geraGnf: false,
                                geraPS: false,
                              });
                            }}
                          />
                        }
                        label="Gerar Pedido"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            className="mr-1 float-center"
                            checked={produtoEditing.geraPS}
                            title="Gerar PS"
                            onChange={event => {
                              setProdutoEditing({
                                ...produtoEditing,
                                geraPS: event.target.checked,
                                geraPedido: false,
                                geraGnf: false,
                              });
                            }}
                          />
                        }
                        label="Gerar PS"
                      />
                    </FormGroup>
                    {/* </Col>
                    <Col> */}
                  </Col>
                </Row>

                <Row>
                  <Box width="100%" mx={2}>
                    <Box
                      display="flex"
                      alignItems="center"
                      mb={0.5}
                      width="100%"
                    >
                      <Typography variant="body2">
                        Produtos para composição de sistema:
                      </Typography>

                      <Tooltip
                        title={
                          <p style={{ fontSize: '1rem' }}>
                            Os produtos selecionados neste campo determinam as
                            regras de precificação para o produto em questão.
                            Caso estejam na mesma proposta, ambos serão
                            precificados conforme produtos selecionados que irão
                            compor um sistema.
                          </p>
                        }
                      >
                        <IconButton size="small">
                          <FaInfoCircle size={12} color="#888787" />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    <SelectProdutos
                      produtos={produtosSelecao}
                      onChange={setProdutosAssociados}
                      value={Object.values(produtosAssociados)}
                      isMulti
                    />
                    {/*
                    <Select
                      closeMenuOnSelect={false}
                      placeholder="Selecione..."
                      isMulti
                      options={produtosSelecao.map(item => ({
                        label: `${item.nome} (${item.ProdutoCategoria?.descricao})`,
                        value: item.id,
                      }))}
                      value={Object.values(produtosAssociados)}
                      onChange={selected => {
                        setProdutosAssociados([...selected]);
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base: any) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    /> */}
                  </Box>
                </Row>

                <Row>
                  <Col sm="12">
                    <FormGroup className="col-sm-14 p-0">
                      <AutocompleteItem
                        key={produtoEditing.id}
                        hideTitle
                        handleSelecionarItem={handleSelecionarItem}
                        noAutoFocus
                        emprCodigo={produtoEditing.codigoEmpresa ?? undefined}
                        usarDiv
                        compact
                        label="Material geração ordem de venda"
                        maxWidth="100vw"
                        valorInput={produtoEditing.materialId}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup className="mb-0">
                  <Row>
                    <Col sm="6" className="mt-0">
                      <AutocompleteItem
                        key={produtoEditing.id}
                        hideTitle
                        handleSelecionarItem={handleSelecionarItemFrete}
                        noAutoFocus
                        emprCodigo={produtoEditing.codigoEmpresa ?? undefined}
                        usarDiv
                        compact
                        obrigatorio={produtoEditing.regramentoProposta}
                        label="Material frete"
                        ignorarMargem
                        // maxWidth="100vw"
                        valorInput={produtoEditing.materialFrete}
                      />
                    </Col>
                    <Col sm="3">
                      <Autocomplete
                        className="ml-2 w-100 p-0"
                        style={{ display: 'flex', alignItems: 'center' }}
                        options={atividades}
                        PopperComponent={PopperMy}
                        getOptionLabel={option =>
                          traduzirProdutoAtividade(option)
                        }
                        value={
                          atividades.find(
                            atividade =>
                              atividade.id === produtoEditing.atividadeFrete,
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setProdutoEditing({
                            ...produtoEditing,
                            atividadeFrete: newValue ? newValue.id : null,
                          });
                        }}
                        renderOption={option => (
                          <>
                            {traduzirProdutoAtividade(option)}
                            {option.codSGE &&
                              ` (Ref. DomSGE: ${option.codSGE})`}
                          </>
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="Atividade frete"
                            className="m-0"
                            margin="dense"
                            required={produtoEditing.regramentoProposta}
                            variant="outlined"
                          />
                        )}
                      />
                    </Col>
                    <Col sm="3">
                      <TextField
                        fullWidth
                        label="Sequência frete"
                        size="small"
                        variant="outlined"
                        required={produtoEditing.regramentoProposta}
                        id="outlined-basic"
                        value={produtoEditing.sequenciaFrete ?? ''}
                        type="number"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            sequenciaFrete: Number(text.target.value),
                          })
                        }
                        InputProps={{ inputProps: { min: 0, max: 10 } }}
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <FormGroup className="mb-0">
                  <Row>
                    <Col sm="6" className="mt-0">
                      <AutocompleteItem
                        key={produtoEditing.nome}
                        hideTitle
                        handleSelecionarItem={handleSelecionarItemMaoObra}
                        noAutoFocus
                        emprCodigo={produtoEditing.codigoEmpresa ?? undefined}
                        obrigatorio={produtoEditing.regramentoProposta}
                        usarDiv
                        compact
                        ignorarMargem
                        label="Material mão obra"
                        maxWidth="100vw"
                        valorInput={produtoEditing.materialMaoObra}
                      />
                    </Col>

                    <Col sm="3">
                      <Autocomplete
                        className="ml-2 w-100 p-0"
                        style={{ display: 'flex', alignItems: 'center' }}
                        options={atividades}
                        PopperComponent={PopperMy}
                        getOptionLabel={option =>
                          traduzirProdutoAtividade(option)
                        }
                        value={
                          atividades.find(
                            atividade =>
                              atividade.id === produtoEditing.atividadeMaoObra,
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setProdutoEditing({
                            ...produtoEditing,
                            atividadeMaoObra: newValue ? newValue.id : null,
                          });
                        }}
                        renderOption={option => (
                          <>
                            {traduzirProdutoAtividade(option)}
                            {option.codSGE &&
                              ` (Ref. DomSGE: ${option.codSGE})`}
                          </>
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="Atividade M/O"
                            className="m-0"
                            margin="dense"
                            required={produtoEditing.regramentoProposta}
                            variant="outlined"
                          />
                        )}
                      />

                      {/* <Input
                        className="ml-2"
                        type="select"
                        value={produtoEditing.atividadeMaoObra ?? ''}
                        required={produtoEditing.regramentoProposta}
                        onChange={text => {
                          setProdutoEditing({
                            ...produtoEditing,
                            atividadeMaoObra: Number(text.target.value),
                          });
                        }}
                      >
                        <option value="">Atividade M/O</option>
                        {atividades.map(atividade => (
                          <option
                            value={atividade.id}
                            title={
                              atividade.codSGE
                                ? `Ref. DomSGE: ${atividade.codSGE}`
                                : ''
                            }
                          >
                            {traduzirProdutoAtividade(atividade)}
                          </option>
                        ))}
                      </Input> */}

                      {/* <TextField
                        fullWidth
                        label="Atividade M/O"
                        size="small"
                        variant="outlined"
                        id="outlined-basic"
                        value={produtoEditing.atividadeMaoObra ?? ''}
                        type="text"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            atividadeMaoObra: String(text.target.value),
                          })
                        }
                        InputProps={{ inputProps: { min: 0, max: 10 } }}
                      /> */}
                    </Col>
                    <Col sm="3">
                      <TextField
                        fullWidth
                        label="Sequência M/O"
                        size="small"
                        variant="outlined"
                        id="outlined-basic"
                        required={produtoEditing.regramentoProposta}
                        value={produtoEditing.sequenciaMaoObra ?? ''}
                        type="number"
                        onChange={text =>
                          setProdutoEditing({
                            ...produtoEditing,
                            sequenciaMaoObra: Number(text.target.value),
                          })
                        }
                        InputProps={{ inputProps: { min: 0, max: 10 } }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-0">
                      <Button
                        className="mb-2"
                        color="danger"
                        type="button"
                        onClick={limparCamposFreteMaoObra}
                      >
                        Limpar campos mão de obra e frete
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>

                <InputGroupAddon className="mt-3" addonType="append">
                  <InputSelectPermiteBotoes />
                </InputGroupAddon>

                <div className="text-center">
                  <Button
                    className="my-4"
                    disabled={
                      !produtoEditing.nome ||
                      (!produtoEditing.codigoEmpresa &&
                        !produtoEditing.setorAtividade) ||
                      !produtoEditing.produtoCategoriaId ||
                      isLoading
                    }
                    color="primary"
                    type="button"
                    onClick={
                      isCreate ? handleCreateProduto : handleUpdateProduto
                    }
                  >
                    {isCreate ? 'Criar' : 'Salvar'}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Modal>
    </>
  );
}
